import React from "react";
import { CheckIcon, GiftIcon, ShoppingCartIcon } from "lucide-react";
import { bonuses } from "../data/bonuses";
import { images, product } from "../data/product";
import { BundleGallery } from "./BundleGallery";
import { CategoryGrid } from "./ui/CategoryGrid";
import { CtaButton } from "./ui/CtaButton";
import { ImageSlot } from "./ui/ImageSlot";
import { Rating } from "./ui/Rating";
import { SectionHeading } from "./ui/SectionHeading";
type BundleOfferProps = {
  id?: string;
  title: React.ReactNode;
  subtitle: string;
  withGallery?: boolean;
};
export function BundleOffer({
  id,
  title,
  subtitle,
  withGallery = false
}: BundleOfferProps) {
  return <section id={id} className="scroll-mt-16 bg-blush px-4 py-14 sm:px-6 sm:py-20" data-id="element-32" data-mp="en4gytr3emlm">
      <SectionHeading title={title} subtitle={subtitle} data-id="element-33" data-mp="9sgmme9eqxz4" />
      <div className="mx-auto mt-8 grid max-w-6xl grid-cols-[minmax(0,1fr)] gap-8 rounded-[32px] border border-line bg-cream p-4 shadow-[0_20px_44px_-30px_rgba(86,18,54,0.55)] sm:p-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-12 lg:p-10" data-id="element-34" data-mp="3i9bfr20el400">
        <div className="w-full min-w-0 lg:sticky lg:top-24 lg:self-start" data-id="element-35" data-mp="14gf9em81ksun">
          {withGallery ? <BundleGallery data-id="element-36" data-mp="19f8gnwwqjnmd" /> : <ImageSlot src={images.heroBundle} alt="Il pacchetto completo con ricette e bonus" placeholderLabel="Mockup del pacchetto" className="aspect-[4/3] w-full rounded-[22px]" data-id="element-37" data-mp="1e9cn8f239tmx" />}
        </div>

        <div className="mx-auto w-full min-w-0 max-w-[480px] px-1 sm:px-0 lg:self-center" data-id="element-38" data-mp="qih2u2zyq0pp">
          <h3 className="text-center font-serif text-[28px] font-semibold leading-[1.15] text-wine sm:text-[34px]" data-id="element-39" data-mp="vi3dc4oep2ut">
            {product.recipes} ricette DIY per la cura del corpo — Il pacchetto completo
          </h3>

          <div className="mt-6" data-id="element-40" data-mp="26xs0aw1nu1vm">
            <CategoryGrid data-id="element-41" data-mp="26wgzn53iha8q" />
          </div>

          <p className="mt-7 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-[15px] text-ink" data-id="element-42" data-mp="2bvthtcjftt4z">
            <span className="rounded-lg bg-chip px-2.5 py-1 font-semibold text-wine" data-id="element-43" data-mp="bt0xoud3g6ik">
              {product.bonusCount} bonus gratuiti
            </span>
            <span data-id="element-44" data-mp="6x3iirdkh67d">
              inclusi <strong className="font-bold text-wine underline underline-offset-2" data-id="element-45" data-mp="kv0jdzz1zyru">solo questo mese</strong>:
            </span>
          </p>
          <ul className="mt-3 space-y-2.5" data-id="element-46" data-mp="gtewrmwpw64g">
            {bonuses.map(b => <li key={b.number} className="flex items-center gap-3 rounded-2xl bg-chip px-4 py-3.5" data-id="element-47" data-mp="3p9rxjp468i2p">
                <GiftIcon className="h-[18px] w-[18px] shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-48" data-mp="3kax5dwkbdh5x" />
                <span className="text-[15px] font-semibold leading-snug text-wine" data-id="element-49" data-mp="1x7dcot4v8q8">{b.name}</span>
              </li>)}
          </ul>

          <div className="mt-8 text-center" data-id="element-50" data-mp="35khjefk2q56p">
            <p className="font-serif text-[48px] font-semibold leading-none text-wine sm:text-[56px]" data-id="element-51" data-mp="35jeq60za3qnm">{product.price}</p>
            <div className="mt-3" data-id="element-52" data-mp="31h1obnnnkcw4">
              <Rating data-id="element-53" data-mp="2rfh6sjpxnmha" />
            </div>
            <div className="mt-6" data-id="element-54" data-mp="2refmdon11nmw">
              <CtaButton icon={<ShoppingCartIcon className="h-5 w-5" strokeWidth={1.75} aria-hidden="true" data-id="element-56" data-mp="2w5numhcmf2yh" />} className="sm:w-full" data-id="element-55" data-mp="2rdct5a28f93t">
                Aggiungi al carrello
              </CtaButton>
            </div>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-sm text-ink" data-id="element-57" data-mp="2mfuv4epr6eal">
              <CheckIcon className="h-4 w-4 text-rose" aria-hidden="true" data-id="element-58" data-mp="3a5p4unerzmqm" />
              Pagamento sicuro e accesso immediato
            </p>
          </div>
        </div>
      </div>
    </section>;
}